import StallReclaimApi, { StallReclaimFile } from "../../api/stall-reclaim/stall-reclaim.api";
import { saveBlobAsFile } from "../depositRefund/depositRefundFile.utils";

export { displayFileName } from "../depositRefund/depositRefundFile.utils";

/**
 * ไฟล์แนบของเมนูนี้ต้องยิงผ่าน StallReclaimApi ไม่ใช่ DepositRefundApi
 *
 * ทำไมไม่ reuse downloadDepositRefundFile ตรงๆ: ตัวนั้นเรียก DepositRefundApi ที่ผ่าน
 * index.ts ซึ่งมีสวิตช์ USE_MOCK_DEPOSIT_REFUND อยู่ — วันไหนมีคนเปิด mock เพื่อ debug
 * เมนูคืนค่ามัดจำ ปุ่มดาวน์โหลดของเมนูนี้จะดับเงียบๆ หาสาเหตุยาก
 * (ส่วน saveBlobAsFile กับ displayFileName เป็น pure ใช้ร่วมกันได้)
 */
export const downloadStallReclaimFile = async (file: StallReclaimFile) => {
  const res = await StallReclaimApi.downloadFile(file.download_url);
  // ใช้ชื่อจาก list ตรงๆ ไม่ต้อง parse Content-disposition ที่ผ่าน encodeURI มา
  saveBlobAsFile(res.data, file.file_name.replace(/^\d{10,}-/, "") || "attachment");
};

/**
 * เปิดดูไฟล์แนบในแท็บใหม่ — ต้องรับ tab ที่ผู้เรียก window.open('', '_blank') ไว้แล้ว
 * ตอน onClick เพราะเปิดหลัง await จะหลุด user gesture แล้วโดน popup blocker
 */
export const openStallReclaimFile = async (file: StallReclaimFile, tab: Window | null) => {
  const res = await StallReclaimApi.downloadFile(file.download_url);

  const url = URL.createObjectURL(res.data);
  if (tab) tab.location.href = url;
  // ให้เวลาแท็บโหลดไฟล์ให้เสร็จก่อน revoke — เร็วกว่านี้ PDF ขนาดใหญ่จะเปิดไม่ขึ้น
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
